// extracted by mini-css-extract-plugin
export default {"dropdown-menu":"dropdownMenu_dropdown-menu__hvmPX bootstrap_dropdown-menu__CH+ov","divider":"dropdownMenu_divider__kSDbA bootstrap_divider__3Ff3Z"};